import { create } from 'zustand'

import type { DocumentTitleSegment } from './format-document-title'

type SegmentList = ReadonlyArray<DocumentTitleSegment>

interface DocumentTitleState {
  // Stack of active title owners (page, plus any open overlays). The last entry
  // wins so an open detail sidebar takes over the tab title, and popping it
  // restores the underlying page's title.
  stack: ReadonlyArray<SegmentList>
  segments: SegmentList
  unreadCount: number
  setSegments: (segments: SegmentList) => void
  clearSegments: (segments: SegmentList) => void
  setUnreadCount: (count: number) => void
}

const EMPTY_SEGMENTS: SegmentList = []

function topOf(stack: ReadonlyArray<SegmentList>): SegmentList {
  return stack.length > 0 ? stack[stack.length - 1] : EMPTY_SEGMENTS
}

export const useDocumentTitleStore = create<DocumentTitleState>((set) => ({
  stack: [],
  segments: EMPTY_SEGMENTS,
  unreadCount: 0,
  setSegments: (segments) =>
    set((state) => {
      const stack = [...state.stack.filter((s) => s !== segments), segments]
      return { stack, segments: topOf(stack) }
    }),
  clearSegments: (segments) =>
    set((state) => {
      const stack = state.stack.filter((s) => s !== segments)
      return { stack, segments: topOf(stack) }
    }),
  setUnreadCount: (unreadCount) => set({ unreadCount }),
}))
